import { render, staticRenderFns } from "./StatisticsAccounting.vue?vue&type=template&id=dff8e630&scoped=true&"
import script from "./StatisticsAccounting.vue?vue&type=script&lang=js&"
export * from "./StatisticsAccounting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff8e630",
  null
  
)

export default component.exports